import { useState } from 'react';
import classNames from 'classnames';
import TopNavbar from './TopNavbar';
import BottomNavbar from './BottomNavbar';

const ExtendedNavbar = () => {
  const [showMainMenu, setShowMainMenu] = useState(false);

  return (
    <nav
      id="header"
      className={classNames(
        'sticky top-0 z-50 w-full bg-white drop-shadow-sm transition duration-300 lg:bg-white lg:drop-shadow-md',
      )}
    >
      <TopNavbar setShowMainMenu={setShowMainMenu} />
      <BottomNavbar
        setShowMainMenu={setShowMainMenu}
        showMainMenu={showMainMenu}
      />
    </nav>
  );
};

export default ExtendedNavbar;
